module.exports = __webpack_public_path__ + "d8123f92b1955c003ec46d20a87366f6.png";